'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useModal, setModalContext } from '@/lib/ui';
export function ModalContextInitializer() {
  const $ = _c(3);
  const modalContext = useModal();
  let t0;
  let t1;
  if ($[0] !== modalContext) {
    t0 = () => {
      setModalContext(modalContext);
    };
    t1 = [modalContext];
    $[0] = modalContext;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}